import { ModuleSetting, NewModuleSetting } from "@models";
import {
	endOfMonth,
	endOfYear,
	isBefore,
	isSameDay,
	startOfDay,
	startOfMonth,
	startOfYear,
	subDays,
} from "date-fns";
import { collisionErrorMessage, isDateRangeWithin, isYearlyBudget } from ".";

type Result = {
	isValid: boolean;
	message: string | undefined;
	isWarning: boolean;
};

export function checkCollidingModuleSettings(
	moduleSettings: ModuleSetting[],
	editingModuleSetting: NewModuleSetting | ModuleSetting,
	availableFrom: Date,
	availableUntil: Date | null
): Result {
	let otherModuleSettings = moduleSettings.filter(
		(ms) => ms.category === editingModuleSetting.category
	);

	if ("moduleSettingId" in editingModuleSetting) {
		otherModuleSettings = otherModuleSettings.filter(
			(ms) => ms.moduleSettingId !== editingModuleSetting.moduleSettingId
		);
	}

	const yearlyBudget = isYearlyBudget(editingModuleSetting.category);

	const colliding = otherModuleSettings.filter((ms: ModuleSetting) =>
		yearlyBudget
			? isDateRangeWithin(
					startOfYear(availableFrom),
					availableUntil && endOfYear(availableUntil),
					ms
			  )
			: isDateRangeWithin(
					startOfMonth(availableFrom),
					availableUntil && endOfMonth(availableUntil),
					ms
			  )
	);

	let message: string | undefined;
	let isWarning = false;
	const errorMessage = collisionErrorMessage.default;
	if (colliding.length === 1) {
		if (isBefore(colliding[0].availableFrom, startOfDay(availableFrom))) {
			const endDate = subDays(availableFrom, 1);
			if (
				!isSameDay(
					availableFrom,
					yearlyBudget
						? startOfYear(availableFrom)
						: startOfMonth(availableFrom)
				)
			) {
				message = yearlyBudget
					? collisionErrorMessage.annualCollision
					: collisionErrorMessage.monthCollision(availableFrom);
				isWarning = false;
			} else {
				message = collisionErrorMessage.monthCollisionChangedEndDate(
					availableFrom,
					endDate
				);
				isWarning = true;
			}
		} else {
			message = errorMessage;
			isWarning = false;
		}
	}

	if (colliding.length > 1) {
		message = errorMessage;
		isWarning = false;
	}

	return {
		isValid: message === undefined,
		message,
		isWarning,
	};
}
